import React, {createElement} from 'react'
import classNames from 'classnames'
import {Button} from 'antd'
import config from './typeConfig'
import styles from './index.less'

class Exception extends React.PureComponent {
    static defaultProps = {
        backText: 'back to home',
        redirect: '/'
    }

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const {
            className,
            backText,
            linkElement = 'a',
            type,
            title,
            desc,
            img,
            actions,
            redirect,
            ...rest
        } = this.props
        const pageType = type in config ? type : '404'
        const clsString = classNames(styles.exception, className)

        return (
            <div className={clsString} {...rest} style={{backgroundImage: `url(${img || config[pageType].img})`, backgroundPosition: 'left', backgroundSize: 'cover'}}>
                {/* <div className={styles.imgBlock}>
                    <div
                        className={styles.imgEle}
                    />
                </div> */}
                <div className={styles.content+' button-positions'}>
                    <div className={styles.actions}>
                        {actions ||
                            createElement(
                                linkElement,
                                {
                                    to: redirect,
                                    href: redirect
                                },
                                <Button type="primary">{backText}</Button>
                            )}


                        <Button onClick={() => {
                            localStorage.removeItem('token')
                            localStorage.removeItem('user')
                            // window.location.reload()
                            window.location.href = '/login'
                        }} type="danger" style={{marginLeft: 10}}>Logout</Button>

                    </div>
                </div>
            </div>
        )
    }
}

export default Exception
